(function() {
  "use strict";

  angular.module("sempraWebapp").service("facilityUtils", facilityUtilsService);

  /** @ngInject */
  function facilityUtilsService(PointTypeEnum, modelUtils) {
    var that = this;

    this.getFacilityPoint = function(deviceJson) {
      deviceJson.point.deviceType = deviceJson.deviceType;
      return deviceJson.point;
      //return deviceJson.points.find(function (pointJson) {
      //  return pointJson.pointType === PointTypeEnum.WASH_FACILITY;
      //});
    };

    this.getFeedValue = function(pointJson, feedReference) {
      return that.FeedReferences.properties[feedReference].getValue(pointJson);
    };

    this.getFeed = function(pointJson, feedReference) {
      return that.FeedReferences.properties[feedReference].getFeed(pointJson);
    };

    this.getActuatorValue = function(pointJson, actuatorReference) {
      return that.ActuatorReferences.properties[actuatorReference].getValue(
        pointJson
      );
    };

    this.getActuator = function(pointJson, actuatorReference) {
      return that.ActuatorReferences.properties[actuatorReference].getActuator(
        pointJson
      );
    };

    this.getTariffs = function(pointJson) {
      return pointJson.actuators.filter(function(actuator) {
        if (actuator.reference.includes("TARIFA")) {
          return actuator;
        }
      });
    };

    //this.isLightCurrentlyOn = function (facilityPoint) {
    //  //todo implement logic based on auto-rucno, rasvjetarad
    //  return that.getFeedValue(facilityPoint, that.FeedReferences.OP_RASVJETA_RAD);
    //};
    //
    //this.areGroupsCurrentlyOn = function (facilityPoint) {
    //  //todo implement logic based on auto-rucno, grupeOn
    //  return that.getActuatorValue(facilityPoint, that.ActuatorReferences.OP_BUTTON_GRUPE_ON);
    //};

    this.FeedReferences = Object.freeze({
      OP_NESTANAK_NAPONA: "OP_NESTANAK_NAPONA",
      OP_UPR_NAPON_24VAC_GRE: "OP_UPR_NAPON_24VAC_GRE",
      OP_BOJLER_GRESKA_MZS: "OP_BOJLER_GRESKA_MZS",
      OP_USIS_KOV_TURBINA_GRESKA: "OP_USIS_KOV_TURBINA_GRESKA",
      OP_FILTER_VODE_ZACEPLJEN: "OP_FILTER_VODE_ZACEPLJEN",
      OPW_ALARM_FILTER_SERVIS: "OPW_ALARM_FILTER_SERVIS",
      OPW_ALARM_BOJLER_SERVIS: "OPW_ALARM_BOJLER_SERVIS",
      OP_RASVJETA_RAD: "OP_RASVJETA_RAD",
      OP_TEMPERATURA_MJERENA: "OP_TEMPERATURA_MJERENA",
      OP_TARIFE_SCHEDULE_ACTIVE_Q: "OP_TARIFE_SCHEDULE_ACTIVE_Q",
      properties: {
        OP_NESTANAK_NAPONA: getFeedPropertiesObject("OP_NESTANAK_NAPONA"),
        OP_UPR_NAPON_24VAC_GRE: getFeedPropertiesObject(
          "OP_UPR_NAPON_24VAC_GRE"
        ),
        OP_BOJLER_GRESKA_MZS: getFeedPropertiesObject("OP_BOJLER_GRESKA_MZS"),
        OP_USIS_KOV_TURBINA_GRESKA: getFeedPropertiesObject(
          "OP_USIS_KOV_TURBINA_GRESKA"
        ),
        OP_FILTER_VODE_ZACEPLJEN: getFeedPropertiesObject(
          "OP_FILTER_VODE_ZACEPLJEN"
        ),
        OPW_ALARM_FILTER_SERVIS: getFeedPropertiesObject(
          "OPW_ALARM_FILTER_SERVIS"
        ),
        OPW_ALARM_BOJLER_SERVIS: getFeedPropertiesObject(
          "OPW_ALARM_BOJLER_SERVIS"
        ),
        OP_RASVJETA_RAD: getFeedPropertiesObject("OP_RASVJETA_RAD"),
        OP_TEMPERATURA_MJERENA: getFeedPropertiesObject(
          "OP_TEMPERATURA_MJERENA"
        ),
        OP_TARIFE_SCHEDULE_ACTIVE_Q: getFeedPropertiesObject(
          "OP_TARIFE_SCHEDULE_ACTIVE_Q"
        )
      }
    });

    this.ActuatorReferences = Object.freeze({
      OP_BUTTON_RASVJETA_AUTO: "OP_BUTTON_RASVJETA_AUTO",
      OP_BUTTON_RASVJETA_ON: "OP_BUTTON_RASVJETA_ON",
      OP_BUTTON_GRUPE_AUTO: "OP_BUTTON_GRUPE_AUTO",
      OP_BUTTON_GRUPE_ON: "OP_BUTTON_GRUPE_ON",
      OP_BUTTON_ANTISMRZ: "OP_BUTTON_ANTISMRZ",
      OP_TEMPER_ANTISMRZ: "OP_TEMPER_ANTISMRZ",
      OP_FILTER_DANI_RADA: "OP_FILTER_DANI_RADA",
      OP_BOJLER_DANI_RADA: "OP_BOJLER_DANI_RADA",
      OP_BUTTON_REV_OSMOZA: "OP_BUTTON_REV_OSMOZA",
      OP_BUTTON_TEHNOLOGIJA: "OP_BUTTON_TEHNOLOGIJA",
      OP_RASVJETA_STOP: "OP_RASVJETA_STOP",
      OP_RASVJETA_START: "OP_RASVJETA_START",
      OP_SCHED_GRUPE_STOP: "OP_SCHED_GRUPE_STOP",
      OP_SCHED_GRUPE_START: "OP_SCHED_GRUPE_START",
      OP_RASVJ_SCHEDULE_START_HOUR: "OP_RASVJ_SCHEDULE_START_HOUR",
      OP_RASVJ_SCHEDULE_START_MINUTE: "OP_RASVJ_SCHEDULE_START_MINUTE",
      OP_RASVJ_SCHEDULE_STOP_HOUR: "OP_RASVJ_SCHEDULE_STOP_HOUR",
      OP_RASVJ_SCHEDULE_STOP_MINUTE: "OP_RASVJ_SCHEDULE_STOP_MINUTE",
      OP_NAPAJ_SCHEDULE_START_HOUR: "OP_NAPAJ_SCHEDULE_START_HOUR",
      OP_NAPAJ_SCHEDULE_START_MINUTE: "OP_NAPAJ_SCHEDULE_START_MINUTE",
      OP_NAPAJ_SCHEDULE_STOP_HOUR: "OP_NAPAJ_SCHEDULE_STOP_HOUR",
      OP_NAPAJ_SCHEDULE_STOP_MINUTE: "OP_NAPAJ_SCHEDULE_STOP_MINUTE",
      OP_TARIFE_SCHEDULE_START_HOUR: "OP_TARIFE_SCHEDULE_START_HOUR",
      OP_TARIFE_SCHEDULE_START_MINUTE: "OP_TARIFE_SCHEDULE_START_MINUTE",
      OP_TARIFE_SCHEDULE_STOP_HOUR: "OP_TARIFE_SCHEDULE_STOP_HOUR",
      OP_TARIFE_SCHEDULE_STOP_MINUTE: "OP_TARIFE_SCHEDULE_STOP_MINUTE",
      OP_TARIFE_SCHEDULE_BUTTON_ENABLE: "OP_TARIFE_SCHEDULE_BUTTON_ENABLE",
      properties: {
        OP_BUTTON_RASVJETA_AUTO: getActuatorPropertiesObject(
          "OP_BUTTON_RASVJETA_AUTO"
        ),
        OP_BUTTON_RASVJETA_ON: getActuatorPropertiesObject(
          "OP_BUTTON_RASVJETA_ON"
        ),
        OP_BUTTON_GRUPE_AUTO: getActuatorPropertiesObject(
          "OP_BUTTON_GRUPE_AUTO"
        ),
        OP_BUTTON_GRUPE_ON: getActuatorPropertiesObject("OP_BUTTON_GRUPE_ON"),
        OP_BUTTON_ANTISMRZ: getActuatorPropertiesObject("OP_BUTTON_ANTISMRZ"),
        OP_TEMPER_ANTISMRZ: getActuatorPropertiesObject("OP_TEMPER_ANTISMRZ"),
        OP_FILTER_DANI_RADA: getActuatorPropertiesObject("OP_FILTER_DANI_RADA"),
        OP_BOJLER_DANI_RADA: getActuatorPropertiesObject("OP_BOJLER_DANI_RADA"),
        OP_BUTTON_REV_OSMOZA: getActuatorPropertiesObject(
          "OP_BUTTON_REV_OSMOZA"
        ),
        OP_TOP_TLAK_REV_OSM: getActuatorPropertiesObject("OP_TOP_TLAK_REV_OSM"),
        OP_ZADRSKA_BFV_OSMOZA: getActuatorPropertiesObject(
          "OP_ZADRSKA_BFC_OSMOZA"
        ),
        OP_ZADRSKA_CRPKA_OSMOZA: getActuatorPropertiesObject(
          "OP_ZADRSKA_CRPKA_OSMOZA"
        ),
        OP_BUTTON_TEHNOLOGIJA: getActuatorPropertiesObject(
          "OP_BUTTON_TEHNOLOGIJA"
        ),
        OP_RASVJETA_STOP: getActuatorPropertiesObject("OP_RASVJETA_STOP"),
        OP_RASVJETA_START: getActuatorPropertiesObject("OP_RASVJETA_START"),
        OP_SCHED_GRUPE_STOP: getActuatorPropertiesObject("OP_SCHED_GRUPE_STOP"),
        OP_SCHED_GRUPE_START: getActuatorPropertiesObject(
          "OP_SCHED_GRUPE_START"
        ),
        OP_RASVJ_SCHEDULE_START_HOUR: getActuatorPropertiesObject(
          "OP_RASVJ_SCHEDULE_START_HOUR"
        ),
        OP_RASVJ_SCHEDULE_START_MINUTE: getActuatorPropertiesObject(
          "OP_RASVJ_SCHEDULE_START_MINUTE"
        ),
        OP_RASVJ_SCHEDULE_STOP_HOUR: getActuatorPropertiesObject(
          "OP_RASVJ_SCHEDULE_STOP_HOUR"
        ),
        OP_RASVJ_SCHEDULE_STOP_MINUTE: getActuatorPropertiesObject(
          "OP_RASVJ_SCHEDULE_STOP_MINUTE"
        ),
        OP_NAPAJ_SCHEDULE_START_HOUR: getActuatorPropertiesObject(
          "OP_NAPAJ_SCHEDULE_START_HOUR"
        ),
        OP_NAPAJ_SCHEDULE_START_MINUTE: getActuatorPropertiesObject(
          "OP_NAPAJ_SCHEDULE_START_MINUTE"
        ),
        OP_NAPAJ_SCHEDULE_STOP_HOUR: getActuatorPropertiesObject(
          "OP_NAPAJ_SCHEDULE_STOP_HOUR"
        ),
        OP_NAPAJ_SCHEDULE_STOP_MINUTE: getActuatorPropertiesObject(
          "OP_NAPAJ_SCHEDULE_STOP_MINUTE"
        ),
        OP_TARIFE_SCHEDULE_START_HOUR: getActuatorPropertiesObject(
          "OP_TARIFE_SCHEDULE_START_HOUR"
        ),
        OP_TARIFE_SCHEDULE_START_MINUTE: getActuatorPropertiesObject(
          "OP_TARIFE_SCHEDULE_START_MINUTE"
        ),
        OP_TARIFE_SCHEDULE_STOP_HOUR: getActuatorPropertiesObject(
          "OP_TARIFE_SCHEDULE_STOP_HOUR"
        ),
        OP_TARIFE_SCHEDULE_STOP_MINUTE: getActuatorPropertiesObject(
          "OP_TARIFE_SCHEDULE_STOP_MINUTE"
        ),
        OP_TARIFE_SCHEDULE_BUTTON_ENABLE: getActuatorPropertiesObject(
          "OP_TARIFE_SCHEDULE_BUTTON_ENABLE"
        )
      }
    });

    function getFeedPropertiesObject(feedReference) {
      return {
        getValue: function(facilityPointJson) {
          return modelUtils.getFeedCurrentValue(
            facilityPointJson,
            feedReference
          );
        },
        getFeed: function(facilityPointJson) {
          return modelUtils.getFeed(facilityPointJson, feedReference);
        }
      };
    }

    function getActuatorPropertiesObject(actuatorReference) {
      return {
        getValue: function(facilityPointJson) {
          return modelUtils.getActuatorCurrentValue(
            facilityPointJson,
            actuatorReference
          );
        },
        getActuator: function(facilityPointJson) {
          return modelUtils.getActuator(facilityPointJson, actuatorReference);
        }
      };
    }
  }
})();
